import React from "react";
import "./about.css";
import { Typewriter } from "react-simple-typewriter";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <>
      <div id="rs-latest-news-style7" className="rs-courses-details">
        <img
          src="assetsfront/images/aboutn.png"
          alt="Banner Image"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />
        <div className="container">
          <div className="row rs-latest-list">
            <h1
              className="title text-center  mt-2 "
              style={{ fontWeight: "700" }}
            >
              Welcome To TopFaculty{" "}
              <strong style={{ color: "#f7b205" }}> About-Us</strong>
            </h1>

            <div className="row">
              <div className="col-lg-6 col-md-12 mobile-mb-50">
                <div className="about-desc">
                  <p>
                    Top Faculty is a revolutionary online platform that connects
                    students with India’s best educators. Whether you’re a
                    student looking for quality learning, a teacher wanting to
                    share knowledge, or a coaching institute aiming to expand,
                    Top Faculty provides the perfect solution.
                  </p>
                  <p>
                    Our platform offers flexible learning options, allowing
                    students to choose full courses or specific topics and learn
                    from the comfort of their homes. Teachers can reach a vast
                    student base, set their own schedules, and grow their
                    careers. Coaching institutes can onboard top tutors and
                    offer structured programs to a wider audience.
                  </p>
                  <p>
                    With a focus on high-quality education, accessibility, and
                    seamless digital learning, Top Faculty is transforming the
                    way India learns. Join us today and be part of the future of
                    education!
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="d-flex justify-content-between creative-image-row">
                  <a href="#" className="w-50 pe-2">
                    <img
                      src="assetsfront/images/about1.jpg"
                      alt="Mission Image"
                      className="creative-img img-left"
                    />
                  </a>
                  <a href="#" className="w-50 ps-2">
                    <img
                      src="assetsfront/images/about2.jpg"
                      alt="Mission Image"
                      className="creative-img img-right"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* why choose-us */}
      <div className="container my-5">
        <div className="row">
          {/* Image Column */}
          <div className="col-md-6 text-center">
            <p class="whyus-hindi">
              टॉपफैकल्टी एक ऐसा प्लेटफॉर्म है जहाँ आपको अनुभवी और प्रमाणित
              शिक्षक मिलते हैं जो आपकी पढ़ाई को एक नई दिशा देने के लिए प्रतिबद्ध
              हैं। हम न केवल शिक्षकों की सत्यता की पुष्टि करते हैं, बल्कि आपको
              आपकी लोकेशन के अनुसार सर्वश्रेष्ठ विकल्प भी प्रदान करते हैं। चाहे
              आप घर पर पढ़ाई करना चाहते हों या ऑनलाइन क्लास में भाग लेना चाहते
              हों, टॉपफैकल्टी हर कदम पर आपके साथ है। हमारी फ्री ट्रायल सेवा और
              समर्पित सपोर्ट टीम के साथ, आपका सीखने का अनुभव सुगम और प्रभावशाली
              बनता है।
            </p>
            <img
              src="assetsfront/images/why3.png"
              alt="Why Choose Us"
              className="img-fluid whyus-image"
            />
          </div>
          {/* Content Column */}
          <div className="col-md-6">
            <h2 className="whyus-title">📌 Why Choose Us</h2>

            <div className="whyus-item whyus-verified">
              <span className="whyus-icon">✅</span>
              <div className="whyus-text">
                <h4>Verified Profiles</h4>
                <p>
                  All tutor profiles are verified manually and by AI for quality
                  and trust.
                </p>
              </div>
            </div>
            <div className="whyus-item whyus-location">
              <span className="whyus-icon">📍</span>
              <div className="whyus-text">
                <h4>Location-Based Search</h4>
                <p>
                  Search for tutors or coaching nearby, making learning more
                  accessible.
                </p>
              </div>
            </div>
            <div className="whyus-item whyus-professional">
              <span className="whyus-icon">👨‍🏫</span>
              <div className="whyus-text">
                <h4>Professional Profiles</h4>
                <p>
                  Each educator displays professional and academic details for
                  transparency.
                </p>
              </div>
            </div>
            <div className="whyus-item whyus-trial">
              <span className="whyus-icon">🎁</span>
              <div className="whyus-text">
                <h4>Free Trial Access</h4>
                <p>Try full platform features for some days completely free.</p>
              </div>
            </div>
            <div className="whyus-item whyus-prime">
              <span className="whyus-icon">🎯</span>
              <div className="whyus-text">
                <h4>TuitionTeacher Prime</h4>
                <p>
                  Get premium tutor matches and a personal manager for support.
                </p>
              </div>
            </div>
            <div className="whyus-item whyus-support">
              <span className="whyus-icon">📚</span>
              <div className="whyus-text">
                <h4>Comprehensive Support</h4>
                <p>
                  Access live/recorded classes, materials, and more from one
                  platform.
                </p>
              </div>
            </div>
            <div className="whyus-item whyus-dedicated">
              <span className="whyus-icon">🤝</span>
              <div className="whyus-text">
                <h4>Dedicated Help</h4>
                <p>
                  Managers and tutors are handpicked with real-time chat
                  assistance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end why choose -us */}
      <div className="about-wrapper">
        <div className=" ">
          <h1 className="title text-center  mt-2 ">
            Top Faculty{" "}
            {/* <strong style={{ color: "#f7b205" }}>
              {" "}
              – Revolutionizing Education in India
            </strong> */}
            <strong style={{ color: "#f7b205" }}>
              <Typewriter
                words={[
                  "  Revolutionizing Education in India",
                  " भारत में शिक्षा का भविष्य",
                ]}
                loop
                cursor
                cursorStyle="."
                typeSpeed={300}
                deleteSpeed={50}
                delaySpeed={2000}
              />
            </strong>
          </h1>{" "}
          <p>
            In today’s rapidly evolving educational landscape, access to quality
            learning resources has become more crucial than ever. Recognizing
            the pressing need for a reliable and innovative platform, Top
            Faculty has emerged as a beacon for students, teachers, and coaching
            institutes across India. We are not just a platform; we are a
            movement dedicated to reshaping how education is delivered and
            consumed in the digital age.
          </p>
        </div>
        {/* English Content */}
        <div className="about-col">
          <div className="about-title">
            Top Faculty – Revolutionizing Education in India
          </div>
          <div className="about-section">
            <h3>📚 Empowering Students</h3>
            <p>
              Top Faculty offers live classes, doubt sessions, and recordings,
              helping students learn flexibly from any location in India.
            </p>
          </div>
          <div className="about-section">
            <h3>👨‍🏫 Empowering Teachers</h3>
            <p>
              We provide a platform where teachers can design their own classes,
              reach more students, and grow professionally with technical
              support.
            </p>
          </div>
          <div className="about-section">
            <h3>🏫 For Coaching Institutes</h3>
            <p>
              Coaching centers can scale their services with our platform,
              reaching online learners and managing classes easily.
            </p>
          </div>
          <div className="about-section">
            <h3>⚙️ Technology-Driven Education</h3>
            <ul>
              <li>🎥 HD live and recorded streaming</li>
              <li>🤖 AI-based course suggestions</li>
              <li>📊 Student progress tracking</li>
              <li>🔒 Secure payment options</li>
            </ul>
          </div>
          <div className="about-section">
            <h3>🌐 Inclusive &amp; Affordable</h3>
            <p>
              We believe in education for all. Our platform offers scholarships
              and affordable rates to reach every learner.
            </p>
          </div>
        </div>
        {/* Hindi Content */}
        <div className="about-col">
          <div className="about-title">
            टॉप फैकल्टी – भारत में शिक्षा का भविष्य
          </div>
          <div className="about-section">
            <h3>📚 छात्रों को सशक्त बनाना</h3>
            <p>
              टॉप फैकल्टी लाइव कक्षाएँ, समाधान सत्र और रिकॉर्डिंग प्रदान करता
              है, जिससे छात्र भारत में कहीं से भी सीख सकते हैं।
            </p>
          </div>
          <div className="about-section">
            <h3>👨‍🏫 शिक्षकों को सशक्त बनाना</h3>
            <p>
              हम एक ऐसा मंच प्रदान करते हैं जहां शिक्षक अपने कोर्स डिज़ाइन कर
              सकते हैं, अधिक छात्रों तक पहुँच सकते हैं और तकनीकी सहायता के साथ
              आगे बढ़ सकते हैं।
            </p>
          </div>
          <div className="about-section">
            <h3>🏫 कोचिंग संस्थानों के लिए</h3>
            <p>
              संस्थान हमारे मंच के ज़रिए अधिक छात्रों तक पहुँच सकते हैं और
              ऑनलाइन कक्षाओं का प्रभावी ढंग से प्रबंधन कर सकते हैं।
            </p>
          </div>
          <div className="about-section">
            <h3>⚙️ तकनीक आधारित शिक्षा</h3>
            <ul>
              <li>🎥 एचडी लाइव और रिकॉर्डिंग स्ट्रीमिंग</li>
              <li>🤖 एआई आधारित कोर्स सुझाव</li>
              <li>📊 छात्र प्रगति निगरानी</li>
              <li>🔒 सुरक्षित भुगतान विकल्प</li>
            </ul>
          </div>
          <div className="about-section">
            <h3>🌐 समावेशी और सस्ती शिक्षा</h3>
            <p>
              हम सभी के लिए शिक्षा में विश्वास रखते हैं। हमारी योजना
              छात्रवृत्तियों और कम शुल्क के माध्यम से हर विद्यार्थी तक पहुँचती
              है।
            </p>
          </div>
        </div>
      </div>
      <div className="topfaculty-section">
        <div className="topfaculty-image">
          <img
            src="assetsfront/images/about3.png"
            alt="Top Faculty Illustration"
          />
        </div>
        <div className="topfaculty-content">
          <h2>📚 Join the Future of Learning</h2>
          <p>
            <strong>टॉप फैकल्टी-</strong>आज के तेजी से बदलते शैक्षिक परिदृश्य
            में गुणवत्तापूर्ण शिक्षा तक पहुँच पहले से कहीं अधिक महत्वपूर्ण हो गई
            है। इसी आवश्यकता को ध्यान में रखते हुए टॉप फैकल्टी एक क्रांतिकारी
            मंच के रूप में उभरा है, जो छात्रों, शिक्षकों और कोचिंग संस्थानों के
            लिए शिक्षा की दुनिया में नए अवसर प्रदान कर रहा है।
          </p>
          <p>
            हम केवल एक प्लेटफ़ॉर्म नहीं, बल्कि एक ऐसा आंदोलन हैं जो डिजिटल युग
            में शिक्षा के स्वरूप को बदलने के लिए समर्पित है
          </p>
           <Link to={"../studentregister"} className="join-btn">
            Join Top Faculty Today
          </Link>
        </div>
      </div>

      
      <h1
        className="title text-center  mt-36 "
        style={{ fontWeight: "700", marginTop: "30px" }}
      >
        FACILITIES
      </h1>{" "}
      <div className="pset">
        <div className="container">
          <div className="row listar-feature-items">
            <div
              className="col-xs-12 col-sm-6 col-md-4 listar-feature-item-wrapper listar-feature-with-image listar-height-changed"
              data-aos="fade-zoom-in"
              data-aos-group="features"
              data-line-height="25.2px"
            >
              <div className="listar-feature-item listar-feature-has-link">
                <a href="#" target="_blank" />
                <div className="listar-feature-item-inner">
                  <div className="listar-feature-right-border" />
                  <div className="listar-feature-block-content-wrapper">
                    <div className="listar-feature-icon-wrapper">
                      <div className="listar-feature-icon-inner">
                        <div>
                          <img
                            alt="Businesses"
                            className="listar-image-icon"
                            src="https://cdn-icons-png.flaticon.com/128/921/921591.png"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="listar-feature-content-wrapper"
                      style={{ paddingTop: 0 }}
                    >
                      <div className="listar-feature-item-title listar-feature-counter-added">
                        <span>
                          <span>01</span>
                          Expert Tutors{" "}
                        </span>
                      </div>
                      <div className="listar-feature-item-excerpt">
                        Learn from India’s best educators for academic and
                        skill-based courses.{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="listar-feature-fix-bottom-padding listar-fix-feature-arrow-button-height" />
            </div>
            <div
              className="col-xs-12 col-sm-6 col-md-4 listar-feature-item-wrapper listar-feature-with-image listar-height-changed"
              data-aos="fade-zoom-in"
              data-aos-group="features"
              data-line-height="25.2px"
            >
              <div className="listar-feature-item listar-feature-has-link">
                <a href="#" target="_blank" />
                <div className="listar-feature-item-inner">
                  <div className="listar-feature-right-border" />
                  <div className="listar-feature-block-content-wrapper">
                    <div className="listar-feature-icon-wrapper">
                      <div className="listar-feature-icon-inner">
                        <div>
                          <img
                            alt="Customers"
                            className="listar-image-icon"
                            src="https://cdn-icons-png.flaticon.com/512/3414/3414151.png"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="listar-feature-content-wrapper"
                      style={{ paddingTop: 0 }}
                    >
                      <div className="listar-feature-item-title listar-feature-counter-added">
                        <span>
                          <span>02</span>
                          Flexible Learning{" "}
                        </span>
                      </div>
                      <div className="listar-feature-item-excerpt">
                        Choose full courses or specific topics and study
                        anytime, anywhere.{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="listar-feature-fix-bottom-padding listar-fix-feature-arrow-button-height" />
            </div>
            <div
              className="col-xs-12 col-sm-6 col-md-4 listar-feature-item-wrapper listar-feature-with-image listar-height-changed"
              data-aos="fade-zoom-in"
              data-aos-group="features"
              data-line-height="25.2px"
            >
              <div className="listar-feature-item listar-feature-has-link">
                <a href="#" target="_blank" />
                <div className="listar-feature-item-inner">
                  <div className="listar-feature-right-border" />
                  <div className="listar-feature-block-content-wrapper">
                    <div className="listar-feature-icon-wrapper">
                      <div className="listar-feature-icon-inner">
                        <div>
                          <img
                            alt="Feedback"
                            className="listar-image-icon"
                            src="https://cdn-icons-png.flaticon.com/512/3412/3412953.png"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="listar-feature-content-wrapper"
                      style={{ paddingTop: 0 }}
                    >
                      <div className="listar-feature-item-title listar-feature-counter-added">
                        <span>
                          <span>03</span>
                          Online Teaching{" "}
                        </span>
                      </div>
                      <div className="listar-feature-item-excerpt">
                        Teachers can set their own schedule and reach a wide
                        student base.{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="listar-feature-fix-bottom-padding listar-fix-feature-arrow-button-height" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
